import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ExtractionRuleListEffects } from './extraction-rule-list.effects';
import { reducer } from './extraction-rule-list.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('extractionRuleList', reducer),
    EffectsModule.forFeature([ExtractionRuleListEffects]),
  ],
  providers: [ExtractionRuleListEffects],
})
export class ExtractionRuleListStoreModule {}
